import "reflect-metadata";

// Other vendors for example jQuery, Lodash or Bootstrap
// You can import js, ts, css, sass, ...
import "@acpaas-ui/aui-kit/dist/css/aui-kit.css";
import "@angular-package/prism";



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!../~/tslint-loader??ref--0!./vendor.ts